import { Pipe, PipeTransform } from '@angular/core';
import { EventContact } from '../../api/models/event-contact';

@Pipe({
  name: 'idToContact',
})
export class IdToContactPipe implements PipeTransform {
  transform(value: number, contacts: Map<number, EventContact>): EventContact | undefined {
    if (value && contacts?.size > 0) {
      return contacts.get(value);
    }
    return undefined;
  }
}
